import React, { useRef } from 'react';
import './ReplaceEditor.scss';
import { Column, Grid } from '../../../../FormComponents/Grid/Grid';
import { Replace } from '../../../../../types/Glossary';
import Help from '../../../../Help/Help';

type Props = {
  data: Replace[];
  setData: React.Dispatch<React.SetStateAction<Replace[]>>;
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
};

export const ReplaceEditor = (props: Props) => {
  const gridRef = useRef<HTMLDivElement>(null);

  const columns: Column<Replace>[] = [
    { key: "find", label: "Word/Phrase to find", type: "text" },
    { key: "replace", label: "Word/Phrase to replace with", type: "text" },
    { key: "match", label: "Case Sensitive", type: "checkbox", width: "100px" }
  ];

  return (
    <>
      <div ref={gridRef} className="replace-editor">
        <p>Used to automatically search for specific words or phrases and replace them with alternative text while preserving surrounding punctuation and only affecting whole words.
        <Help
          title="🔍 Find & Replace"
          text={`<br/><b>Purpose:</b> Used to search for a specific word or phrase and replace it with another text automatically.<br/><br/><b>Description:</b> Matching is case-insensitive and only affects whole words, not parts of other words. The match can appear before punctuation (e.g., "hello,", "world!") without removing the punctuation.<br/><br/><b>Example:</b><br/>Find → colour<br/>Replace → color<br/>Result:<br/>"The colour, red!" → "The color, red!"<br/><br/><b>General Notes:</b><br/>Only exact word matches are replaced — "test" will not change "contest".<br/>Punctuation such as . , ! ? ; : is preserved.<br/>Rules are applied in the order they appear in the list.<br/>Avoid overlapping or circular replacements (e.g., replacing foo with bar and bar with foo).`}
          maxWidth='660px'
        /></p>
        <Grid<Replace>
          columns={columns}
          data={props.data}
          setData={props.setData}
          setIsDirty={props.setIsDirty}
          maxHeight={220} />
      </div>
    </>
  );
};
